export default __webpack_public_path__ + "static/media/newQUICK.e7ad0669.svg";